module.exports = __webpack_public_path__ + "static/media/tea-wai.557dfd73.jpg";